export default __webpack_public_path__ + "static/media/maximize-ticket.b14c210d.svg";